module.exports = __webpack_public_path__ + "img/85ne.85359b9c.svg";